import type { CourseRegistered } from '@/types/composition-functions';

export function registrationModuleGroups(courses: CourseRegistered[]) {
  const groups = new Map<string, CourseRegistered[]>();
  for (const course of courses) {
    const key = course.programme_module_id ?? course.module_name ?? '';
    const rows = groups.get(key) ?? [];
    rows.push(course);
    groups.set(key, rows);
  }

  return {
    hasModules: courses.some(course => !!(course.programme_module_id || course.module_name)),
    rows: [...groups.entries()]
      .sort(([, a], [, b]) =>
        (a[0]?.module_sequence ?? Number.MAX_SAFE_INTEGER)
        - (b[0]?.module_sequence ?? Number.MAX_SAFE_INTEGER),
      )
      .flatMap(([key, rows]) => rows.map(course => ({ ...course, moduleGroupKey: key }))),
  };
}
